import React, { useEffect, useState } from 'react';
import {
     collection,
     addDoc,
     query,
     where,
     getDocs,
     deleteDoc,
     doc,
     updateDoc,
     increment,
     getDoc
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { Bookmark, BookmarkBorder } from '@mui/icons-material';
import { toastedError, toastedSuccess } from '../config/toast';

const BookmarkButton = ({ problemId }) => {
     const [saved, setSaved] = useState(false);
     const [bookmarkId, setBookmarkId] = useState(null);
     const [loading, setLoading] = useState(false);

     const user = JSON.parse(localStorage.getItem('user'));

     // 🔍 Check already bookmarked
     useEffect(() => {
          const checkBookmark = async () => {
               if (!user?.uid) return;

               const q = query(
                    collection(db, 'bookmarks'),
                    where('problemId', '==', problemId),
                    where('userId', '==', user.uid)
               );

               const snap = await getDocs(q);

               if (!snap.empty) {
                    setSaved(true);
                    setBookmarkId(snap.docs[0].id);
               }
          };

          checkBookmark();
     }, [problemId, user]);

     // 🔥 Toggle bookmark
     const handleBookmark = async () => {
          if (!user?.uid) {
             toastedError("Login required to save ideas");
               return;
          }

          if (loading) return;

          try {
               setLoading(true);

               if (saved) {
                    await deleteDoc(doc(db, 'bookmarks', bookmarkId));

                    // Get current count first to prevent negative
                    const problemSnap = await getDoc(doc(db, 'problems', problemId));
                    const currentCount = problemSnap.data()?.bookmarkCount || 0;
                    await updateDoc(doc(db, 'problems', problemId), {
                         bookmarkCount: Math.max(0, currentCount - 1)
                    });

                    setSaved(false);
                    setBookmarkId(null);
                    toastedError("Removed from bookmarks");
               } else {
                    const ref = await addDoc(collection(db, 'bookmarks'), {
                         problemId,
                         userId: user.uid,
                         createdAt: new Date(),
                    });
                    await updateDoc(doc(db, 'problems', problemId), { bookmarkCount: increment(1) });
                    setSaved(true);
                    setBookmarkId(ref.id);
                    toastedSuccess("Saved to bookmarks");
               }

          } catch (error) {
               console.error('Bookmark error:', error?.code, error?.message);
               toastedError("Failed to update bookmark");
          } finally {
               setLoading(false);
          }
     };

     return (
          <button
               className={`action-btn bookmark-btn ${saved ? 'saved' : ''}`}
               onClick={handleBookmark}
          >
               {saved ? <Bookmark/> : <BookmarkBorder/>} 
          </button>
     );
};

export default BookmarkButton;